module.exports = __webpack_public_path__ + "static/media/astronauta_3.c98ef62f.svg";